const baseOptions = [
  {
    name: "General",
    type: "Section",
    fields: [
      {
        name: "min",
        type: "Int",
      },
      {
        name: "max",
        type: "Int",
      },
      {
        name: "minorTicks",
        type: "Int",
      },
      {
        name: "majorTicks",
        type: "Int",
      },
    ],
  },
];

const options = [
  {
    name: "Green",
    primitive: false,
    type: "Section",
    fields: [
      {
        name: "greenColor",
        type: "String",
      },
      {
        name: "greenFrom",
        type: "Int",
      },
      {
        name: "greenTo",
        type: "Int",
      },
    ],
  },
  {
    name: "Red",
    primitive: false,
    type: "Section",
    fields: [
      {
        name: "redColor",
        type: "String",
      },
      {
        name: "redFrom",
        type: "Int",
      },
      {
        name: "redTo",
        type: "Int",
      },
    ],
  },
  {
    name: "Yellow",
    primitive: false,
    type: "Section",
    fields: [
      {
        name: "yellowColor",
        type: "String",
      },
      {
        name: "yellowFrom",
        type: "Int",
      },
      {
        name: "yellowTo",
        type: "Int",
      },
    ],
  },
];

export default {
  baseOptions,
  options,
};
